import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-level-price",
  templateUrl: "./level-price.component.html",
  styleUrls: ["./level-price.component.css"]
})
export class LevelPriceComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
